import { PageTitle } from "../../components/company/ui";
import ReviewsPanel from "../../components/reviews/ReviewsPanel";
import { useT } from "../../i18n";

/** Reviews of companies after completed rentals, and companies' reviews of the driver. */
export default function DriverReviews() {
  const t = useT();
  return (
    <>
      <PageTitle>{t.reviews.title}</PageTitle>
      <ReviewsPanel role="driver" />
    </>
  );
}
